import React from "react";
import "./styles.less";

// import { useTranslation } from "react-i18next";

export const CommonBlogRqcode = (props) => {
  return (
    <>
      <div className="blog-rqcode">
        <div className="rqcode-img">
          <img
            height="80px"
            src="//files.authing.co/authing-blog/auting-qrcode.svg"
            alt="authing blog rqcode"
          />
        </div>
        <div className="rqcode-content">
          <div className="rqcode-title">关注 Authing 公众号</div>
          <div className="rqcode-subtitle">随时随地发现更多内容</div>
        </div>
      </div>

      <div className="blog-rqcode">
        <div
          style={{
            marginLeft: 0,
          }}
          className="rqcode-img"
        >
          <img
            height="70px"
            src="//files.authing.co/authing-blog/authing-qrcode.v3.jpeg"
            alt="authing blog rqcode"
          />
        </div>
        <div className="rqcode-content">
          <div className="rqcode-title">添加 Authing 小助手</div>
          <div className="rqcode-subtitle">加入 Authing 开发者大家庭</div>
        </div>
      </div>
    </>
  );
};
